export interface Offer {
  id: number;
  name: string;
  digitalOfferCode: string;
  couponCode: string;
  description: string;
  allowDefaultContent: boolean;
  imageHeight: number;
  imageWidth: number;
  validFrom: string;
  validTo: string;
  bannerImageUrl: string;
  rules: OfferRules;
  onlineOnly: boolean;
  redemptionDateTimeUtc?: string;
  redeemed: boolean;
  overrideContent: OfferLocationOverrideContent[];
}
export interface OfferRules {
  addItemsAfterValidation?: OfferParentRecipe[];
  filterMenu?: OfferRecipeCategories;
  priceOverride?: OfferPriceOverrideFilter[];
  validation?: OfferValidationItem[];
}
export interface OfferPriceOverrideFilter extends OfferFilterItems {
  discount: number;
  discountType: OfferDiscountType;
  matchDefaultComponents: boolean;
}
export interface OfferFilterItems {
  categories: OfferRecipeCategories;
  recipes: OfferParentRecipe[];
  customizationGroups: OfferCustomizationGroup[];
  useMenuFilterRecipes: boolean;
}

export interface OfferCustomizationGroup {
  customizationGroupId: number;
  modifierGroups: OfferModifierGroup[];
}
export interface OfferModifier {
  modifierId: number;
}

export interface OfferModifierGroup {
  modifierGroupId: number;
  modifiers: OfferModifier[];
}

export enum OfferDiscountType {
  None = "None",
  Amount = "Amount",
  Percent = "Percent",
  Override = "Override"
}
export interface OfferLocationOverrideContent {
  id: number;
  offerId: number;
  name: string;
  description: string;
  imageHeight: number;
  imageWidth: number;
  effectiveDateTimeLocal: string | null;
  expiryDateTimeLocal: string | null;
  bannerImageUrl: string;
  regions: number[];
}

export class ChildRecipesOffer {
  attachToOffer: Boolean;
  childRecipeId: Number;
}
export interface OfferChildRecipe {
  childRecipeId: number;
  attachToOffer: boolean;
}

export interface OfferRecipeCategory {
  categoryId: number;
  recipes?: OfferParentRecipe[];
}
export interface OfferRecipeCategories extends Array<OfferRecipeCategory> {

}

export interface OfferParentRecipe {
  recipeId: number;
  childRecipes?: OfferChildRecipe[];
}

export class ChildRecipes { 
  childRecipeId: Number;
}
export interface OfferValidationItem {
  rules: OfferValidationRule[];
  operator: OfferValidationOperator;
  alert: OfferAlert;
}
export enum OfferValidationOperator {
  AndOperator = 1,
  OrOperator = 2
}

export interface OfferAlert {
  messageTitle: string;
  messageDetail: string;
  buttons: OfferAlertButton[];
}

export interface OfferAlertButton {
  title: string;
  action: string;
  style: OfferAlertButtonStyle;
}

export enum OfferAlertButtonStyle {
  Default = 0,
  Cancel = 1
}

export interface OfferValidationRule extends OfferFilterItems {
  minCount: number | null;
  maxCount: number | null;
}

